






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ScrollToTop extends Vue {
  isShow: boolean = false
  mounted () {
    this.listenScroll()
  }
  scrollToTop () {
    if (window.requestAnimationFrame) {
      let scrollLoop = (function () {
        return function () {
          if (window.scrollY > 1) {
            window.scroll(0, window.scrollY / 1.5)
            window.requestAnimationFrame(scrollLoop)
          }
        }
      })()
      window.requestAnimationFrame(scrollLoop)
    } else {
      window.scroll(0, 0)
    }
  }
  listenScroll () {
    window.addEventListener('scroll', this.handleIsShow)
  }
  handleIsShow () {
    if (window.scrollY > window.innerHeight / 10) {
      this.isShow = true
    } else {
      this.isShow = false
    }
  }
}
